import { Snackbar, Theme } from '@ifca-ui/core'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider'
import { Button, CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import AppContext from 'containers/context/Context'
import { RootInitialState, RootReducer } from 'containers/context/Reducer'
import * as React from 'react'
import { BrowserRouter } from 'react-router-dom'
import 'assets/styles/app.scss'
import { client } from '../../client'
import { loadingObservable } from '../helper/loadingHelper'
import { snackBarObservable } from '../helper/snackBarSubjectHelper'
import NavigationProvider from './NavigationProvider'
import { useEffect } from 'react'
import { ApolloProvider } from '@apollo/client'
import 'assets/styles/standard.scss'
import { MainRoutes } from '../routes/RootRoutes'
import 'assets/styles/app.scss'
//import '@ifca-ui/core/dist/styles/style.css'
import AppUrlListener from './AppUrlListener'

export default function App() {
  const [rootState, rootDispatch] = React.useReducer(
    RootReducer,
    RootInitialState
  )

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    rootDispatch({
      type: 'snackBar',
      payload: {
        open: false,
        message: '',
      },
    })
  }

  useEffect(() => {
    loadingObservable().subscribe(x => {
      rootDispatch({
        type: 'loading',
        payload: x,
      })
    })

    snackBarObservable().subscribe(x => {
      if (x) {
        rootDispatch({
          type: 'snackBar',
          payload: {
            open: true,
            message: x,
          },
        })
      }
    })
  }, [])

  return (
    <ThemeProvider theme={Theme}>
      <ApolloProvider client={client}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AppUrlListener />
          <AppContext.Provider value={{ rootState, rootDispatch }}>
            <BrowserRouter>
              <NavigationProvider />
              <MainRoutes />
            </BrowserRouter>
            <Snackbar
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              message={rootState.snackBar?.message}
              open={rootState.snackBar?.open}
              onClose={handleClose}
              autoHideDuration={2000}
              action={
                <Button color="secondary" size="small" onClick={handleClose}>
                  DISMISS
                </Button>
              }
            />
          </AppContext.Provider>
        </LocalizationProvider>
      </ApolloProvider>
    </ThemeProvider>
  )
}
